.container {
  position: fixed;
  bottom: var(--space-6);
  right: var(--space-6);
  z-index: var(--z-toast);
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  pointer-events: none;
  max-width: 380px;
}

.toast {
  display: flex;
  align-items: flex-start;
  gap: var(--space-3);
  padding: var(--space-4);
  background: var(--color-bg-panel);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-lg);
  pointer-events: auto;
  animation: slideIn var(--transition-base) ease-out;
  position: relative;
  overflow: hidden;
  background-image: linear-gradient(180deg, rgba(255,255,255,0.05) 0%, transparent 100%);
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateX(100%) translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}

/* Type variants */
.success {
  border-left: 4px solid var(--color-online);
}

.success .iconWrapper {
  color: var(--color-online);
}

.error {
  border-left: 4px solid var(--color-red);
}

.error .iconWrapper {
  color: var(--color-red);
}

.info {
  border-left: 4px solid var(--color-cyan);
}

.info .iconWrapper {
  color: var(--color-cyan);
}

.warning {
  border-left: 4px solid var(--color-gold);
}

.warning .iconWrapper {
  color: var(--color-gold);
}

.iconWrapper {
  display: flex;
  flex-shrink: 0;
  margin-top: 2px;
}

.icon {
  width: 20px;
  height: 20px;
}

.content {
  flex: 1;
  min-width: 0;
}

.title {
  font-family: var(--font-body);
  font-weight: 700;
  font-size: 13px;
  color: var(--color-text);
  line-height: 1.3;
}

.message {
  margin-top: var(--space-1);
  font-family: var(--font-body);
  font-size: 12px;
  color: var(--color-text-dim);
  line-height: 1.4;
}

.action {
  margin-top: var(--space-3);
  padding: var(--space-1) var(--space-3);
  font-family: var(--font-body);
  font-weight: 700;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--color-text-inverse);
  background: var(--color-primary);
  border-radius: var(--radius-sm);
  transition: background var(--transition-fast);
}

.action:hover {
  background: var(--color-primary-hover);
}

.close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  flex-shrink: 0;
  color: var(--color-text-muted);
  background: transparent;
  border: none;
  border-radius: var(--radius-sm);
  transition: all var(--transition-fast);
}

.close:hover {
  color: var(--color-text);
  background: var(--color-bg-input);
}

.closeIcon {
  width: 16px;
  height: 16px;
}

.progress {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3px;
  background: currentColor;
  opacity: 0.6;
  border-radius: 0 0 var(--radius-lg) var(--radius-lg);
  animation: progress var(--transition-base) linear forwards;
}

@keyframes progress {
  from { width: 100%; }
  to { width: 0%; }
}

/* Type-specific progress colors */
.success .progress { color: var(--color-online); }
.error .progress { color: var(--color-red); }
.info .progress { color: var(--color-cyan); }
.warning .progress { color: var(--color-gold); }